import React, { Component } from 'react';
import {
  Typography,
  Grid,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import { Delete, Edit } from '@material-ui/icons';
import AddIcCallIcon from '@material-ui/icons/AddIcCall';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import Backgroundscroll from '../../Backgroundscroll';
import ProviderEditModal from '../../components/ProviderEditModal';
import TelemedicineEditModal from '../../components/TelemedicineEditModal';
import AdministratorEditModal from '../../components/AdministratorEditModal';
import Avatar from '../../components/Avatar'
import './style.css'

import {
  fetchAllProvidersForPractice,
  updateProvider,
} from '../../services/api';
import * as adminApi from '../../services/api/admin';
import * as authApi from '../../services/api/auth';
import AdministratorDeleteModal from '../../components/AdministratorDeleteModal';

class ProviderAdminPractices extends Component {
  state = {
    practice: {},
    providers: [],
    administrators: [],
    openProviderModal: false,
    openTelemedicineModal: false,
    providerUnderEdit: {},
    administratorUnderEdit: {},
    administratorUnderDelete: {},
    openAdministratorModal: false,
    openAdministratorDeleteModal: false,
    isLoading: true,
  };

  async componentDidMount() {
    try {
      this.setState({ isLoading: true });
      const currentPractice = await this.fetchCurrentPractice();
      await this.fetchProviders(currentPractice);
      await this.fetchAdministrators(currentPractice);
    } catch (err) {
      console.error(err);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  async fetchCurrentPractice() {
    const practice = await authApi.fetchCurrentPractice();
    this.setState({ practice });
    return practice;
  }

  async fetchProviders(practice) {
    const providers = await fetchAllProvidersForPractice({
      practiceId: practice.id,
    });
    this.setState({ providers });
  }

  async fetchAdministrators(practice) {
    const administrators = await adminApi.fetchAdministrators({
      practiceId: practice.id,
    });
    this.setState({ administrators });
  }

  onEditProvider = provider => {
    this.setState({ openProviderModal: true, providerUnderEdit: provider });
  };

  onEditTelemedicine = provider => {
    this.setState({ openTelemedicineModal: true, providerUnderEdit: provider });
  };

  onEditAdministrator = administrator => {
    this.setState({
      openAdministratorModal: true,
      administratorUnderEdit: administrator,
    });
  };

  onDeleteAdministrator = administrator => {
    this.setState({
      openAdministratorDeleteModal: true,
      administratorUnderDelete: administrator,
    });
  };

  onClose = () => {
    this.setState({
      openProviderModal: false,
      providerUnderEdit: {},
      openAdministratorModal: false,
      openAdministratorDeleteModal: false,
      openTelemedicineModal: false,
      administratorUnderEdit: {},
      administratorUnderDelete: {},
    });
  };
  onSaveProvider = async provider => {
    try {
      await updateProvider(provider);
      this.props.enqueueSnackbar('Provider updated!');
      this.onClose();
    } catch (err) {
      console.log(err);
      this.props.enqueueSnackbar(
        'Oops, something went wrong. Please Try again'
      );
    } finally {
      this.fetchProviders(this.state.practice);
    }
  };

  onSaveProviderTenancies = async tenancies => {
    try {
      await Promise.all(
        tenancies.map(tenancy => {
          if (tenancy.id) {
            return adminApi.updateTenancy(tenancy);
          } else {
            return adminApi.createTenancy(tenancy);
          }
        })
      );
      this.props.enqueueSnackbar('Provider updated!');
      this.onClose();
    } catch (err) {
      console.log(err);
      this.props.enqueueSnackbar(
        'Oops, updating locations for provider failed'
      );
    } finally {
      this.fetchProviders(this.state.practice);
    }
  };

  onSaveAdministrator = async administrator => {
    try {
      console.log('Admin',administrator);
      if (administrator.id) {
        await adminApi.updateAdministrator(administrator);
      } else {
        await adminApi.createAdministrator(administrator);
      }
      this.props.enqueueSnackbar('Administrator updated!');
      this.onClose();
    } catch (err) {
      console.error(err);
      this.props.enqueueSnackbar('Oops, updating administrator failed');
    } finally {
      this.fetchAdministrators(this.state.practice);
    }
  };

  handleDeleteAdministrator = async administrator => {
    try {
      if (administrator.id) {
        await adminApi.deleteAdministrator(administrator);
      }
      this.props.enqueueSnackbar('Administrator deleted!');
      this.onClose();
    } catch (err) {
      console.error(err);
      this.props.enqueueSnackbar('Oops, deleting administrator failed');
    } finally {
      this.fetchAdministrators(this.state.practice);
    }
  };

  render() {
    const { classes } = this.props;
    const {
      administrators,
      providers,
      openProviderModal,
      providerUnderEdit,
      openAdministratorModal,
      openAdministratorDeleteModal,
      administratorUnderEdit,
      administratorUnderDelete,
      isLoading,
      openTelemedicineModal,
    } = this.state;

    if (isLoading) {
      return (
        <div className={classes.loading}>
          <CircularProgress />
        </div>
      );
    }
 
    return (
      <div className={classes.root}>
        <Grid container className="practiceMain">
          <Grid item xs={12} classes={{ item: classes.section }}>
            <Paper classes={{ root: classes.sectionPaper }} style={{ width: 'fit-content' }}>
              <header className={classes.sectionHeader}>
                <Typography
                  variant="h5"
                  classes={{ root: classes.sectionHeaderText }}
                >
                  Providers
                </Typography>
              </header>

              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Locations</TableCell>
                    <TableCell>Actions</TableCell>
                    <TableCell>Telemedicine</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {providers.map(provider => (
                    <TableRow key={provider.id}>
                      <TableCell width="300">
                        <Grid container alignItems="center">
                          <Grid
                            item
                            xs={12}
                            xl={3}
                          >  
                            <Avatar
                              providerId ={provider.id}
                              customStyles = {{
                                width: '40px',
                                height:'40px',
                                marginLeft:'0px',
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} xl={9}>
                            {provider.name}
                          </Grid>
                        </Grid>
                      </TableCell>
                      <TableCell width="300">{provider.email}</TableCell>
                      <TableCell>
                        {provider.tenancies
                          .filter(l => l.active)
                          .map(l => l.shortName || l.location)
                          .join(', ')}
                      </TableCell>
                      <TableCell>
                        <IconButton
                          onClick={() => this.onEditProvider(provider)}
                        >
                          <Edit />
                        </IconButton>
                      </TableCell>
                      <TableCell>
                        <IconButton
                          onClick={() => this.onEditTelemedicine(provider)}
                        >
                          <AddIcCallIcon style={{ fill: '#a86ff7' }} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Paper>

            {openProviderModal && (
              <ProviderEditModal
                open={openProviderModal}
                provider={providerUnderEdit}
                saveProfile={this.onSaveProvider}
                saveTenancies={this.onSaveProviderTenancies}
                onClose={this.onClose}
              />
            )}
            {openTelemedicineModal && (
              <TelemedicineEditModal
                open={openTelemedicineModal}
                provider={providerUnderEdit}
                onClose={this.onClose}
              />
            )}
          </Grid>

          <Grid item xs={12} classes={{ item: classes.section }}>
            <Paper classes={{ root: classes.sectionPaper }}>
              <header className={classes.sectionHeader}>
                <Typography
                  variant="h5"
                  classes={{ root: classes.sectionHeaderText }}
                >
                  Administrators
                </Typography>
              </header>

              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {administrators.map(administrator => (
                    <TableRow key={administrator.id}>
                      <TableCell width="300">{administrator.name}</TableCell>
                      <TableCell width="300">{administrator.email}</TableCell>
                      <TableCell>
                        <IconButton
                          onClick={() =>
                            this.onEditAdministrator(administrator)
                          }
                        >
                          <Edit />
                        </IconButton>
                        <IconButton
                          onClick={() =>
                            this.onDeleteAdministrator(administrator)
                          }
                        >
                          <Delete />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>

              <Grid
                container
                justifyContent="flex-end"
                classes={{ container: classes.extras }}
              >
                <Grid item xs={12} md={6} xl={2}>
                </Grid>
              </Grid>
            </Paper>
            <Button
                    fullWidth
                    color="primary"
                    variant="contained"
                    onClick={this.onEditAdministrator}
                  >
                    + Add Administrator
            </Button>

            {openAdministratorModal && (
              <AdministratorEditModal
                open={openAdministratorModal}
                administrator={administratorUnderEdit}
                save={this.onSaveAdministrator}
                onClose={this.onClose}
              />
            )}

            {openAdministratorDeleteModal && (
              <AdministratorDeleteModal
                open={openAdministratorDeleteModal}
                administrator={administratorUnderDelete}
                onDelete={this.handleDeleteAdministrator}
                onClose={this.onClose}
              />
            )}
          </Grid>
        </Grid>
      </div>
    );
  }
}

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  root: {
    padding: '3em',
  },
  section: {
    marginBottom: '3em',
  },
  sectionPaper: {
    padding: '1em 1em',
  },
  sectionHeader: {
    paddingTop: '1em',
    paddingLeft: '1em',
    paddingBottom: '1em',
  },
  sectionHeaderText: {
    fontSize: '1.5em',
    lineHeight: '19px',
    color: '#1C1C1C',
  },
  extras: {
    paddingTop: '1em',
  },
});

export default Backgroundscroll(withSnackbar(withStyles(styles)(ProviderAdminPractices)));
